import { useInlineFullscreenActive } from '@/components/tiptap-editor/tiptap-ui/fullscreen-activity';
import { useEffect, useState, type CSSProperties } from 'react';

/** Above inline fullscreen node views (`zIndex: 51` in node-view-wrapper). */
export const TABLE_CONTROLS_ELEVATED_Z_INDEX = 52;

const ELEVATED_PORTAL_LAYER_STYLE: CSSProperties = {
    position: 'fixed',
    inset: 0,
    zIndex: TABLE_CONTROLS_ELEVATED_Z_INDEX,
    pointerEvents: 'none',
};

const SCROLL_SETTLE_MS = 150;

export function useTableControlsPortal(widgetContainer: HTMLElement | undefined) {
    const elevated = useInlineFullscreenActive();
    return {
        portalRoot: elevated ? undefined : widgetContainer,
        portalLayerStyle: elevated ? ELEVATED_PORTAL_LAYER_STYLE : undefined,
        fixedStrategy: elevated,
    };
}

export function useHideTableControlsWhileScrolling(): boolean {
    const [isScrolling, setIsScrolling] = useState(false);

    useEffect(() => {
        let timeout: ReturnType<typeof setTimeout>;

        const onScroll = () => {
            setIsScrolling(true);
            clearTimeout(timeout);
            timeout = setTimeout(() => setIsScrolling(false), SCROLL_SETTLE_MS);
        };

        document.addEventListener('scroll', onScroll, true);
        return () => {
            document.removeEventListener('scroll', onScroll, true);
            clearTimeout(timeout);
        };
    }, []);

    return isScrolling;
}
